import {call} from 'redux-saga/effects';
import {get} from './api';

export default (flows) => {
  flows.getFlow('get').setActions({
    onFetch: function* () {
      const response = yield call(() => get());

      return { success: true, status: response.status };
    },

    onFail: (action, error, formattedError) =>
      error.response
        ? error.response.status
        : formattedError,
  });

  return flows.getSagas();
};
